import { render, staticRenderFns } from "./AuthSliderComponent.vue?vue&type=template&id=8564e314"
import script from "./AuthSliderComponent.vue?vue&type=script&lang=js"
export * from "./AuthSliderComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthSliderComponent.vue?vue&type=style&index=0&id=8564e314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports